// extracted by mini-css-extract-plugin
export var dualRing = "styles-module--dualRing--e012b";
export var loadingSpinner = "styles-module--loadingSpinner--9499a";
export var ringAnimation = "styles-module--ringAnimation--9736b";